import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { useInactivityTimeout } from '../hooks/useInactivityTimeout';
import { SessionExpiredModal, SessionWarningBanner } from '../components/SessionExpiredModal';
import './GroupSelection.css';


import { API } from '../config';

export default function GroupSelection({ user }) {
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { sessionExpired, showWarning, handleSessionLogout, dismissWarning } = useInactivityTimeout();

  useEffect(() => {
    loadGroups();
  }, []);

  const loadGroups = async () => {
    try {
      const response = await axios.get(`${API}/groups`);
      setGroups(response.data);
    } catch (error) {
      toast.error('Failed to load groups');
    } finally {
      setLoading(false);
    }
  };

  const selectGroup = (groupId) => {
    navigate(`/member-dashboard/${groupId}`);
  };

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div className="group-selection-page" data-testid="group-selection-page">
      {sessionExpired && <SessionExpiredModal onLogin={handleSessionLogout} />}
      {showWarning && !sessionExpired && <SessionWarningBanner onDismiss={dismissWarning} />}
      <div className="group-selection-container">
        <div className="selection-header">
          <h1>Welcome to Your Member Portal</h1>
          <p>Select your group to view payments and updates</p>
        </div>

        {groups.length === 0 ? (
          <div className="no-groups card">
            <div className="empty-icon">💭</div>
            <h3>No Groups Found</h3>
            <p>You're not currently a member of any groups. Contact your group leadership to be added.</p>
          </div>
        ) : (
          <div className="groups-grid">
            {groups.map((group) => (
              <div 
                key={group.id} 
                className="group-card card"
                onClick={() => selectGroup(group.id)}
                data-testid={`group-card-${group.id}`}
              >
                <div className="group-icon">👥</div>
                <h3>{group.name}</h3>
                <p>{group.description}</p>
                <div className="group-details">
                  <div className="detail-item">
                    <span className="detail-label">Payment:</span>
                    <span className="detail-value">${group.payment_amount}</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Frequency:</span>
                    <span className="detail-value">{group.payment_frequency}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}